import React from 'react';


export default function WaitFor({ statuses, predicate, children, fallback = null }) {
  if (statuses) {
    return (
      <WaitForStatuses statuses={statuses}>
        {children}
      </WaitForStatuses>
    );
  } else if (predicate)
    return children;
  else
    return fallback;
}

function WaitForStatuses({ statuses, children }) {
  const isReady = getIsReady(statuses);
  return (
    <WaitFor predicate={isReady}>
      {children}
    </WaitFor>
  );
}


function getIsReady(statuses) {
  if (Array.isArray(statuses))
    return statuses.every(({ readStatus }) => readStatus.succeeded);
  else if (statuses instanceof Object)
    return statuses.readStatus?.succeeded ?? false;
  else
    return false;
}
